<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link v-if ="current_role == 'super_admin'" class="navbar-brand" to="/dashboard"></b-link>
    <b-link v-if ="current_role == 'analyst'" class="navbar-brand" to="/dashboard"></b-link>
    <b-link v-if ="current_role == 'marketing_accountant'" class="navbar-brand" to="/dashboard"></b-link>
    <b-link v-if ="current_role == 'super_analyst'" class="navbar-brand" to="/dashboard"></b-link>
    <b-link v-if ="current_role == 'trucking_company_admin'" class="navbar-brand" to="/dash"></b-link>
    <b-link v-if ="current_role == 'trucking_operational_manager'" class="navbar-brand" to="/dash"></b-link>
    <b-link v-if ="current_role == 'trucking_company_admin_light'" class="navbar-brand" to="/hauls"></b-link>
    <b-link v-if ="current_role == 'operations_manager'" class="navbar-brand" to="/dashboard"></b-link>

    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-navbar-nav class="d-md-down-none">
      <b-nav-item v-show="view" class="px-3"><router-link to="/dashboard">Dashboard</router-link></b-nav-item>
      <b-nav-item v-show="current_role !== 'trucking_company_admin' && current_role !== 'trucking_company_admin_light' && current_role !== 'trucking_operational_manager'" class="px-3"><router-link to="/reports">Reports</router-link></b-nav-item>
      <b-nav-item v-show="view1" class="px-3"><router-link to="/hauls">Hauls</router-link></b-nav-item>
      <b-nav-item v-show="current_role === 'super_admin' || current_role === 'super_analyst' || current_role === 'analyst' || current_role === 'marketing_accountant'" class="px-3"><router-link to="/targets">Nominations</router-link></b-nav-item>
      <b-nav-item v-show="!view1" class="px-3"><router-link to="/users">Users</router-link></b-nav-item>
    </b-navbar-nav>
    <b-navbar-nav class="ml-auto header-username">
      <HeaderDropdownAccnt/>
    </b-navbar-nav>
  </header>
</template>
<script>
  import HeaderDropdownAccnt from './HeaderDropdownAccnt.vue'

  export default {
    name: 'appheader',
        created: function () {
      var current_role = localStorage.getItem('role')
      if (current_role == 'trucking_company_admin' || current_role == 'trucking_operational_manager') {
        this.view = false
        this.view1 = true 
        this.op='/dash'  
      } else if (current_role == 'trucking_company_admin_light') {
        this.view = false
        this.view1 = true 
        this.op='/hauls' 
      } else {
        this.view = true 
        this.view1 = true 
        this.op='/dashboard'
      }
    },
    components: {
      HeaderDropdownAccnt
    },
    data: () => {
      return {
        view : true,
        current_role : localStorage.getItem('role'),
      }
    },
    methods: {
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      asideToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('aside-menu-hidden')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/Header.vue